import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import {contingentSectionModule, loadRetired} from '../ContingentSectionDucks';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import {DepartColumns} from './DepartColumns'
export default function DepartPage() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(state => state[contingentSectionModule].retired);
  const loadingTable = useSelector(state => state[contingentSectionModule].loadingTable);
  const { nextPage } = useTableFilter(filter =>
    dispatch(loadRetired({filter}))
  );
  return (
    <div className='mt1'>
      <StaticTablePagination
        sortable={false}
        loading={loadingTable}
        columns={DepartColumns({
          t,
          lang: i18n.language,
         })
        }
        totalElements={data.totalElements}
        data={data.content}
        urlOnClick={row => `/contingent/section/${row.original.id}`}
        onClickLoadMore={() => nextPage()}
      />
    </div>
  );
}

